import React from 'react';
import styled from '@emotion/styled';

const StyledMegamenuClose = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 10px;
  z-index: 1000;
  top: 65px;
  right: 16px;
  opacity: 0.48;
  border-radius: 4px;
  display: flex;
  z-index: 2;
`;

export default StyledMegamenuClose;
